import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-92c4a1ea.js';
import { i as isSameArray, a as arrayIncludes } from './p-d7a5de56.js';
import { Q as stopEvent, V as findElementInEventPath, N as getSiblings } from './p-a57042e3.js';
import { a as ComponentUtils } from './p-de830ba7.js';
const expandableGroupCss = ".sc-owc-expandable-group-h{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;border:var(--one-spacing-outline-regular) solid var(--one-color-background-contrast);border-radius:var(--one-spacing-radius-5-xs);overflow-y:visible !important}.sc-owc-expandable-group-h owc-expandable.sc-owc-expandable-group{border-radius:0;-webkit-box-shadow:inset 0 calc(-1 * var(--one-spacing-outline-regular)) 0 0 var(--one-color-background-contrast);box-shadow:inset 0 calc(-1 * var(--one-spacing-outline-regular)) 0 0 var(--one-color-background-contrast)}.sc-owc-expandable-group-h owc-expandable.sc-owc-expandable-group>.owc-expandable__control-wrapper.sc-owc-expandable-group:hover{-webkit-box-shadow:inset 0 calc(-1 * var(--one-spacing-outline-regular)) 0 0 var(--one-color-background-contrast);box-shadow:inset 0 calc(-1 * var(--one-spacing-outline-regular)) 0 0 var(--one-color-background-contrast)}.sc-owc-expandable-group-h owc-expandable.sc-owc-expandable-group:first-of-type{border-top-right-radius:inherit;border-top-left-radius:inherit}.sc-owc-expandable-group-h owc-expandable.sc-owc-expandable-group:last-of-type{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit;border-bottom:none;-webkit-box-shadow:none;box-shadow:none}.sc-owc-expandable-group-h owc-expandable.sc-owc-expandable-group:last-of-type>.owc-expandable__control-wrapper.sc-owc-expandable-group:hover{-webkit-box-shadow:none;box-shadow:none}.sc-owc-expandable-group-h owc-expandable.owc-expandable--variant-transparent.sc-owc-expandable-group{-webkit-box-shadow:none;box-shadow:none}.sc-owc-expandable-group-h owc-expandable.owc-expandable--variant-transparent.sc-owc-expandable-group>.owc-expandable__control-wrapper.sc-owc-expandable-group:hover{-webkit-box-shadow:none;box-shadow:none}.sc-owc-expandable-group-h owc-expandable.owc-expandable--variant-filled.owc-expandable--disabled.sc-owc-expandable-group{-webkit-box-shadow:inset 0 calc(-1 * var(--one-spacing-outline-regular)) 0 0 var(--one-color-interaction-disabled-intensity-low);box-shadow:inset 0 calc(-1 * var(--one-spacing-outline-regular)) 0 0 var(--one-color-interaction-disabled-intensity-low)}.sc-owc-expandable-group-h owc-expandable.owc-expandable--variant-filled.owc-expandable--disabled.sc-owc-expandable-group:last-of-type{-webkit-box-shadow:none;box-shadow:none}.sc-owc-expandable-group-h owc-expandable.owc-expandable--expanded.sc-owc-expandable-group>.owc-expandable__control-wrapper.sc-owc-expandable-group:hover{-webkit-box-shadow:none;box-shadow:none}";
const OwcExpandableGroupStyle0 = expandableGroupCss;
const EXPANDABLE_COMPONENT_TAG = 'owc-expandable';
const ExpandableGroup = /*@__PURE__*/proxyCustomElement(class ExpandableGroup extends H {
  constructor() {
    super();
    this.__registerHost();
    this.expandedElementsChanged = createEvent(this, "expandedElementsChanged", 3);
    this.component = new ComponentUtils(this);
    this.multiple = false;
    this.expanded = [];
    this.allDisabled = false;
  }
  onExpandedChange(event) {
    stopEvent(event);
    const element = findElementInEventPath(event, EXPANDABLE_COMPONENT_TAG);
    const elementIndex = this.getItems().findIndex(el => el === null || el === void 0 ? void 0 : el.isSameNode(element));
    elementIndex >= 0 && this.toggleExpandedState(elementIndex, event.detail);
  }
  onExpandedChanged(newValue, oldValue) {
    if (!isSameArray(newValue, oldValue)) {
      this.getItems().forEach((el, index) => {
        el.expanded = arrayIncludes(newValue, index);
      });
      this.expandedElementsChanged.emit(newValue);
    }
  }
  /** Method to expand/collapse all expandable elements within the group */
  async setAllState(state) {
    this.getItems().forEach((item, index) => {
      if (!item.disabled) {
        item.expanded = state;
        this.toggleExpandedState(index, state);
      }
    });
    return Promise.resolve();
  }
  componentDidLoad() {
    const expandedElements = this.getItems().map((el, i) => el.expanded ? i : -1).filter(index => index >= 0);
    this.expanded = expandedElements.length ? this.multiple ? expandedElements : expandedElements.slice(-1) : [];
  }
  componentWillRender() {
    const items = this.getItems();
    this.allDisabled = items.length && items.every(item => !!item.disabled);
  }
  getItems() {
    return getSiblings(this.hostElement.querySelector(EXPANDABLE_COMPONENT_TAG), el => el.tagName.toLowerCase() === EXPANDABLE_COMPONENT_TAG);
  }
  toggleExpandedState(elementIndex, expanded) {
    if (expanded) {
      if (this.multiple) {
        !arrayIncludes(this.expanded, elementIndex) && (this.expanded = [...this.expanded, elementIndex].sort((a, b) => a - b));
      } else {
        this.expanded = [elementIndex];
      }
    } else {
      this.expanded = this.expanded.filter(item => item !== elementIndex);
    }
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      multiple: this.multiple
    });
    return h(Host, {
      key: '0fda5526e7b13bb1379860120dc2bb7d0501b25a',
      class: hostClasses
    }, h("slot", {
      key: '75ea25209e6cf750b18c8868cb0266de05f57707'
    }));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "expanded": ["onExpandedChanged"]
    };
  }
  static get style() {
    return OwcExpandableGroupStyle0;
  }
}, [6, "owc-expandable-group", {
  "multiple": [516],
  "expanded": [32],
  "allDisabled": [32],
  "setAllState": [64]
}, [[0, "expandedChange", "onExpandedChange"]], {
  "expanded": ["onExpandedChanged"]
}]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-expandable-group"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-expandable-group":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, ExpandableGroup);
        }
        break;
    }
  });
}
const OwcExpandableGroup = ExpandableGroup;
const defineCustomElement = defineCustomElement$1;
export { OwcExpandableGroup, defineCustomElement };